module.exports = __webpack_public_path__ + "static/media/Karima.f7b9fa36.jpg";